var map = {
	"./abc-news-au.jpg": 373,
	"./abc-news.jpg": 374,
	"./axios.jpg": 375,
	"./bbc-news.jpg": 376,
	"./bloomberg.jpg": 377,
	"./cbc-news.jpg": 378,
	"./cbs-news.jpg": 379,
	"./cnn.jpg": 380,
	"./fox-news.jpg": 381,
	"./google-news-au.jpg": 382,
	"./google-news-ca.jpg": 383,
	"./google-news-in.jpg": 384,
	"./google-news-uk.jpg": 385,
	"./google-news.jpg": 47,
	"./medical-news-today.jpg": 386,
	"./national-geographic.jpg": 387,
	"./nbc-news.jpg": 388,
	"./new-scientist.jpg": 389,
	"./news24.jpg": 390,
	"./next-big-future.jpg": 391,
	"./the-times-of-india.jpg": 392,
	"./the-wall-street-journal.jpg": 393,
	"./the-washington-post.jpg": 394,
	"./the-washington-times.jpg": 395,
	"./time.jpg": 396,
	"./usa-today.jpg": 397,
	"./who.jpg": 398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;